import React, { forwardRef } from 'react';
import { Button } from 'design-system-web';

export type ButtonVariants =
  | 'outlined'
  | 'outlined-light'
  | 'contained'
  | 'contained-dark';

type Props = {
  className?: string;
  disabled?: boolean;
  children?: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
  onClick?: (event?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  style?: React.CSSProperties;
  variant?: ButtonVariants;
  loading?: boolean;
};

const variantMap = {
  outlined: 'secondary',
  'outlined-light': 'secondary',
  contained: 'primary',
  'contained-dark': 'primary',
} as const;

export const LegacyButton = forwardRef<HTMLButtonElement | null, Props>(
  (
    {
      onClick = () => null,
      children,
      disabled = false,
      loading = false,
      fullWidth,
      className,
      style,
      variant = 'outlined',
      size = 'medium',
    },
    ref
  ) => {
    const mappedSize = size === 'small' ? 'medium' : 'large';
    const mappedVariant = variantMap[variant];

    return (
      <Button
        ref={ref}
        onClick={onClick}
        disabled={disabled}
        loading={loading}
        fullWidth={fullWidth}
        className={className}
        style={style}
        variant={mappedVariant}
        size={mappedSize}
      >
        {children}
      </Button>
    );
  }
);